import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import {
  removeItem,
  addQuantity,
  subtractQuantity,
  updateItems,
  clearCart
} from "./cartActions";
import Recipe from "./Recipe";
import OrderConfirmation from "./OrderConfirmation";

class Cart extends Component {
  state = {
    orderComplete: false,
    paymentMethod: ""
  };

  //loads the products from public/products/products.json, falls sie noch
  //nicht im Redux-Store liegen (z.B. bei Direktaufruf von /warenkorb)
  componentDidMount() {
    window.scrollTo(0, 0);
    if (!this.props.categories || this.props.categories.length === 0) {
      fetch("products/products.json")
        .then(response => response.json())
        .then(result => {
          this.props.updateItems(result.items, result.categories);
        });
    }
  }

  handleRemove = id => {
    this.props.removeItem(id);
  };
  handleAddQuantity = id => {
    this.props.addQuantity(id);
    this.forceUpdate();
  };
  handleSubtractQuantity = id => {
    this.props.subtractQuantity(id);
    this.forceUpdate();
  };

  handleOrderComplete = paymentMethod => {
    this.setState({ orderComplete: true, paymentMethod });
    this.props.clearCart();
    if (this.props.onOrderStateChange) {
      this.props.onOrderStateChange(true);
    }
    window.scrollTo(0, 0);
  };

  renderRow = item => {
    const { t } = this.props;
    return (
      <div className="cart-rd-row" key={item.id}>
      <span className="cart-rd-name">{item.subtitle}</span>
      <div className="cart-rd-qty">
        <button
          type="button"
          className="cart-rd-step"
          aria-label={t("warenkorb.Qty less")}
          onClick={() => this.handleSubtractQuantity(item.id)}
        >
          <i className="fa fa-minus-circle" aria-hidden="true"></i>
        </button>
        <span className="cart-rd-qty-num">{item.quantity}</span>
        <button
          type="button"
          className="cart-rd-step"
          aria-label={t("warenkorb.Qty more")}
          onClick={() => this.handleAddQuantity(item.id)}
        >
          <i className="fa fa-plus-circle" aria-hidden="true"></i>
        </button>
      </div>
      <span className="cart-rd-price">
        {(Math.round(item.price * item.quantity * 100) / 100).toFixed(2)} CHF
      </span>
      <button
        type="button"
        className="cart-rd-remove"
        aria-label={t("warenkorb.Remove item")}
        onClick={() => this.handleRemove(item.id)}
      >
        <i className="fa fa-trash" aria-hidden="true"></i>
      </button>
      </div>
    );
  };

  render() {
    if (this.state.orderComplete) {
      return (
        <div className="container">
          <div className="cart cart-rd" id="cart-start">
            <OrderConfirmation paymentMethod={this.state.paymentMethod} />
          </div>
        </div>
      );
    }

    const { t } = this.props;
    const items = this.props.items;

    return (
      <div className="container">
        <div className="cart cart-rd" id="cart-start">
          <h2 className="cart-rd-title">{t("warenkorb.Overview title")}</h2>

          <div className="cart-rd-group">
            <div className="cart-rd-group-head">{t("warenkorb.Selection heading")}</div>
            {items.length === 0 ? (
              <p className="cart-rd-empty">{t("warenkorb.Empty")}</p>
            ) : (
              items.map(this.renderRow)
            )}
            <Link to="/unser-honig" className="cart-rd-shop-link">
              {t("warenkorb.Shop link")} <span className="arr">→</span>
            </Link>
          </div>

          <Recipe onOrderComplete={this.handleOrderComplete} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    items: state.addedItems,
    categories: state.categories
  };
};

const mapDispatchToProps = dispatch => {
  return {
    removeItem: id => {
      dispatch(removeItem(id));
    },
    addQuantity: id => {
      dispatch(addQuantity(id));
    },
    subtractQuantity: id => {
      dispatch(subtractQuantity(id));
    },
    updateItems: (items, categories) => {
      dispatch(updateItems(items, categories));
    },
    clearCart: () => {
      dispatch(clearCart());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Cart));
